export default __webpack_public_path__ + "static/media/logo.52ca74bf.png";